import script from "./deliverTheWholeMachineSample.vue?vue&type=script&setup=true&lang=js"
export * from "./deliverTheWholeMachineSample.vue?vue&type=script&setup=true&lang=js"

import "./deliverTheWholeMachineSample.vue?vue&type=style&index=0&id=6dcf8626&lang=scss&scoped=true"
import "./deliverTheWholeMachineSample.vue?vue&type=style&index=1&id=6dcf8626&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dcf8626"]])

export default __exports__